import * as React from "react";
import SelectField from "components/form/select-field";
import { Form } from "formsy-react";
import Checkbox from "material-ui/Checkbox";
import { formatMessage } from "lib/globalize-util";
import {
    SHOW_DOORS,
    SHOW_TOTAL_RETAIL,
    SHOW_COLOR_SWATCH,
    SHOW_UNITS,
    SHOW_TOTAL_COST,
    NONE,
    SHOW_EACHES_ON_HOVER,
    TILE_LINE_SETTINGS,
} from "./constants";
import { TooltipHost } from "@nuorder/components";
import theme from "styles/theme";
import InfoIcon from "@material-ui/icons/Info";
import { merge, $ } from "glamor";
import { ITileSettings } from "./types";
import { DATATEST } from "constants/integration";

const muiStyles = {
    toolTip: {
        color: theme.palette.white,
    },
};

const styles = merge(
    $(" .linesContainer > div", {
        display: "block !important",
        marginLeft: "2px",
    }),
    $(" .checkboxContainer", {
        marginTop: "10px",
    }),
    $(" .optionsCheck", {
        margin: "10px 0",
    }),
    $(" .optionsCheckWithInfo", {
        width: "200px !important",
        display: "inline-block !important",
        marginTop: 0,
    }),
    $(" .infoIcon", {
        width: "24px",
        height: "24px",
        color: theme.palette.grey,
    })
);

interface IProps {
    tileSettings: ITileSettings;
    onLineChange: (key: string) => (event, index, status) => void;
    onCheckboxChange: (event, status) => void;
    options: React.ReactNode;
    hasAllocationDimensions: boolean;
}

export const FormView: React.FunctionComponent<IProps> = ({
    tileSettings,
    options,
    onLineChange,
    onCheckboxChange,
    hasAllocationDimensions,
}) => {
    return (
        <Form>
            <div {...styles}>
                <div className="linesContainer">
                    {TILE_LINE_SETTINGS.map((line) => (
                        <SelectField
                            key={line.name}
                            label={<span className="label">{formatMessage(line.label)}</span>}
                            onChange={onLineChange(line.name)}
                            value={tileSettings[line.name] || NONE}
                            name={line.name}
                            dataTest={line.dataTest}
                        >
                            {options}
                        </SelectField>
                    ))}
                </div>
                <div className="checkboxContainer">
                    <Checkbox
                        className="optionsCheck"
                        checked={tileSettings.showColorSwatch}
                        value={SHOW_COLOR_SWATCH}
                        onCheck={onCheckboxChange}
                        label={formatMessage("Show Color Swatch")}
                        data-test={DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.COLOR_SWATCH}
                    />
                    {hasAllocationDimensions && (
                        <>
                            <Checkbox
                                className="optionsCheck"
                                checked={tileSettings.showUnits}
                                value={SHOW_UNITS}
                                onCheck={onCheckboxChange}
                                label={formatMessage("Show Units")}
                                data-test={DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.UNITS}
                            />
                            <Checkbox
                                className="optionsCheck"
                                checked={tileSettings.showDoors}
                                value={SHOW_DOORS}
                                onCheck={onCheckboxChange}
                                label={formatMessage("Show Doors")}
                                data-test={DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.DOORS}
                            />
                        </>
                    )}
                    <Checkbox
                        className="optionsCheck"
                        checked={tileSettings.showTotalCost}
                        value={SHOW_TOTAL_COST}
                        onCheck={onCheckboxChange}
                        label={formatMessage("Show Cost")}
                        data-test={DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.TOTAL_COST}
                    />
                    <Checkbox
                        className="optionsCheck"
                        checked={tileSettings.showTotalRetail}
                        value={SHOW_TOTAL_RETAIL}
                        onCheck={onCheckboxChange}
                        label={formatMessage("Show Retail")}
                        data-test={DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.TOTAL_RETAIL}
                    />
                    {hasAllocationDimensions && (
                        <div>
                            <Checkbox
                                className="optionsCheck optionsCheckWithInfo"
                                checked={tileSettings.showEachesOnHover}
                                value={SHOW_EACHES_ON_HOVER}
                                onCheck={onCheckboxChange}
                                disabled={!tileSettings.showTotalCost && !tileSettings.showTotalRetail}
                                label={formatMessage("Show eaches on hover")}
                                data-test={DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.EACHES_ON_HOVER}
                            />

                            <TooltipHost
                                content={
                                    <span style={muiStyles.toolTip}>
                                        {formatMessage("Display prices for individual products")}
                                    </span>
                                }
                                tooltipProps={{
                                    calloutProps: {
                                        styles: {
                                            beak: { background: theme.palette.darkestGrey },
                                            beakCurtain: { background: theme.palette.darkestGrey },
                                            calloutMain: {
                                                background: theme.palette.darkestGrey,
                                            },
                                        },
                                    },
                                }}
                            >
                                <InfoIcon className="infoIcon" />
                            </TooltipHost>
                        </div>
                    )}
                </div>
            </div>
        </Form>
    );
};
